/**
 * 全局存储模块
 * 用于在不同组件间共享数据，特别是URL参数等需要跨页面传递的信息
 */

// 全局存储对象
const globalStore = {
  // 存储URL参数
  urlParams: {},
  
  /**
   * 设置URL参数
   * @param {Object} params - URL参数对象
   */
  setUrlParams(params) {
    this.urlParams = { ...params };
    // 也可以考虑存储到localStorage，以便在页面刷新后保持参数
    try {
      localStorage.setItem('globalUrlParams', JSON.stringify(this.urlParams));
    } catch (error) {
      console.warn('无法保存URL参数到localStorage:', error);
    }
  },
  
  /**
   * 获取URL参数
   * @returns {Object} URL参数对象
   */
  getUrlParams() {
    return { ...this.urlParams };
  },
  
  /**
   * 初始化全局存储
   * 从localStorage恢复参数（如果有）
   */
  init() {
    try {
      const savedParams = localStorage.getItem('globalUrlParams');
      if (savedParams) {
        this.urlParams = JSON.parse(savedParams);
      }
    } catch (error) {
      console.warn('无法从localStorage恢复URL参数:', error);
    }
  }
};

// 初始化全局存储
globalStore.init();

export default globalStore;